import Login from "../features/auth/LogicPresenter";
import NavigationBar from "../ui/NavigationBar";
import React from "react";

const LoginPage = () => {
  return (
    <div className="bg-form-page h-screen">
      <NavigationBar />
      <div className="-mt-20 flex h-screen flex-col justify-center">
        <Login />
      </div>
    </div>
  );
};

export default LoginPage;
